
import { Component, Mixins } from 'vue-property-decorator';
import { getAddressString } from '@/utils/address.util';
import { format as formatPhone } from "@/utils/phone.util";
import { mapState } from 'vuex';
import "vue2-editor/dist/vue2-editor.css";
import AuthMixin from '@/common/mixins/auth.mixin';
import CreateEditNoteModal from "../components/vacancy-create-edit-note-modal.vue";
import EmployeeDetails from '@/common/components/employee/employee-details.vue';
import { OfficeDto } from '@/types/office.type';
import { VacancyApplicantDto, VacancyDetailsDto } from '@/types/vacancy.type';

@Component({
  components: {
    EmployeeDetails,
    CreateEditNoteModal
  },
  computed: {
    ...mapState("Vacancy", { details: "vacancyDetails" }),
    ...mapState("Shift", ["selectedOffice"])
  }
})
export default class VacancyApplicantComponent extends Mixins(AuthMixin) {
  details!: VacancyDetailsDto;

  currentEmployee!: { userId: number, practiceId: number };
  selectedOffice!: OfficeDto;

  isEmployeeDetailsVisible = false;

  fields = [
    { key: 'isHired', label: 'Hired' },
    'name',
    'email',
    { key: 'phoneNumber', label: 'Phone' },
    { key: 'isInterested', label: 'Internal Use Only', thClass: 'internal' }
  ];

  Math = Math;
  formatPhone = formatPhone;

  get address(): string {
    return getAddressString(this.details);
  }

  async getData(): Promise<void> {
    await this.$store.dispatch("Vacancy/getDetails",  { id: this.details.id, practiceId: this.userInfo()?.practiceId });
  }

  getFormattedDate(date: string): string {
    return new Date(date).toLocaleDateString();
  }

  async updateInterest(userId: number, vacancyId: number, isInterested: boolean | null): Promise<void> {
    const applicant = this.details.applicants
      .find(applicant => applicant.vacancyId === vacancyId && applicant.userId === userId);

    if (applicant?.isInterested === isInterested) {
      isInterested = null;
    }

    await this.$store.dispatch("Vacancy/updateInterest", { userId, vacancyId, isInterested });
    await this.$store.dispatch("Vacancy/getDetails",  { id: this.details.id, practiceId: this.userInfo()?.practiceId });
  }

  async updateHire(userId: number, vacancyId: number): Promise<void> {
    await this.$store.dispatch("Vacancy/updateHire", { userId, vacancyId });
    await this.$store.dispatch("Vacancy/getDetails",  { id: this.details.id, practiceId: this.userInfo()?.practiceId });
  }

  isFavoriteChanged(data: { isFavorite: boolean }): void {
    const applicant = this.details.applicants.find(applicant => applicant.userId == this.currentEmployee?.userId);
    if (applicant) {
      applicant.isFavorite = data.isFavorite;
    }
  }

  onClose(): void { 
    this.$store.dispatch("Vacancy/resetDetails");
  }

  async onNoteChange(userId: number): Promise<void> {
    await this.getData();
    this.$store.commit('Vacancy/updateField', { path: 'vacancyApplicant', value: this.details.applicants.find(a => a.userId === userId) });
  }

  closeModal(): void {
    this.$bvModal.hide('vacancy-applicant-modal');
  }

  showEmployeeDetailsModal(userId: number): void {
    this.currentEmployee = { userId: userId, practiceId: this.userInfo()?.practiceId ?? 0 };
    this.isEmployeeDetailsVisible = true;
  }

  showNoteModal(item: VacancyApplicantDto): void {
    this.$store.commit('Vacancy/updateField', { path: 'vacancyApplicant', value: item });
    this.$bvModal.show("vacancy-create-edit-note-modal");
  }
}
